var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPerformanceSpeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1F1F1F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.303 38.744a17.441 17.441 0 0012.329-29.77c-6.845-6.6-17.715-6.5-24.439.223S2.37 26.79 8.971 33.636a17.323 17.323 0 0012.332 5.108zm-11.22-28.66c6.217-6.08 16.168-6.025 22.316.124 6.148 6.148 6.204 16.099.124 22.315a15.758 15.758 0 01-11.22 4.648 15.868 15.868 0 01-11.22-27.087zm3.45 3.449a10.988 10.988 0 0118.758 7.77h1.573c0-6.938-5.624-12.562-12.563-12.562-6.938 0-12.562 5.624-12.562 12.562h1.573a10.917 10.917 0 013.22-7.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6 24.8l-.086-.123 5.975-9.033-1.31-.869-5.91 8.94a3.146 3.146 0 101.33 1.084zm-3.898 2.728a1.593 1.593 0 112.609-1.827 1.593 1.593 0 01-2.61 1.827z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerformanceSpeed);
export default __webpack_public_path__ + "static/media/ic_performance_speed.4328c509d987ee4c83a39a1eaf5c305a.svg";
export { ForwardRef as ReactComponent };